<div class="timepicker">
  <!-- <mat-select
  #picker
  [value]="selectTime"
  [placeholder]="placeholder"
  [disabled]="form.disabled"
>
  <mat-option
    *ngFor="let option of options"
    [value]="option"
    (click)="onOptionClick(option)"
  >
    {{ option }}
  </mat-option>
</mat-select> -->
  <input
    type="text"
    dateformat
    [date]="dateValue" 
    [dateFormat]="format"
    matInput
    [formControl]="form"
    [placeholder]="placeholder"
    [class.disabled]="disabled"
    [style]="inputStyle"
    inputmode="numeric"
    (blur)="dateUpdate($event)"
  />
  <ng-container *ngIf="!disabled">
    <button
    type="button"
    mat-icon-button
    aria-label="時間を選択する"
    [disabled]="form.disabled"
    (click)="triggerDial()"
  >
    <mat-icon svgIcon="clock"></mat-icon>
  </button>
</ng-container>
</div>
<ng-container *ngIf="form.invalid && (form.dirty || form.touched)">
  <mat-error *ngIf="form.hasError('required') || form.hasError('pattern')"
    >時間を入力して下さい</mat-error
  >
</ng-container>
